// extracted by mini-css-extract-plugin
export default {"privacyPolicy":"Privacypolicy_privacyPolicy__aUdYD","container":"Privacypolicy_container__RK1oy","title":"Privacypolicy_title__vWaRS"};